const TABBING_CLASS = 'user-is-tabbing';

export const initKeyboardFocusVisibility = (): (() => void) => {
	const handleKeyDown = (event: KeyboardEvent) => {
		if (event.key === 'Tab') {
			document.documentElement.classList.add(TABBING_CLASS);
		}
	};

	const handlePointerDown = () => {
		document.documentElement.classList.remove(TABBING_CLASS);
	};

	document.addEventListener('keydown', handleKeyDown);
	document.addEventListener('pointerdown', handlePointerDown, true);

	return () => {
		document.removeEventListener('keydown', handleKeyDown);
		document.removeEventListener('pointerdown', handlePointerDown, true);
	};
};
